<template>
  <div>
    <div class="text-left pd-b-3 flex-display ai-center js-end pd-t-4">
      <a
        @click="resetTopic(),setCourse(),dialogTopicVisible = true"
        class="color-primary-light"
        >+ เพิ่มหัวข้อ</a
      >
    </div>
    <div>
      <el-table
        v-if="showTable"
        v-loading="loadingTable"
        :data="topicList"
        border
        :header-row-style="tableHeaderStyle"
        :header-cell-style="tableHeaderStyle"
        :default-sort="{ prop: 'index', order: 'ascending' }"
        empty-text="ไม่พบข้อมูล"
      >
        <el-table-column
          prop="index"
          label="ลำดับ"
          header-align="center"
          align="center"
          width="80"
          sortable
        ></el-table-column>
        <el-table-column
          prop="topic"
          label="ชื่อหัวข้อ"
          header-align="center"
          sortable
          :width="widthMax < 767.98 ? '160' : ''"
        ></el-table-column>
        <el-table-column
          prop="attach"
          label="คลิปหัวข้อบทเรียน"
          width="200"
          header-align="center"
          align="center"
          sortable
        >
          <template slot-scope="scope">
            <a
              :href="`${urlCouse}${$route.query.courseId}/${scope.row.attach.file}`"
              target="_blank"
              class="color-primary-light text-underline"
              >{{ scope.row.attach.file }}</a
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="durationTime"
          label="เปิด-ปิดหัวข้อ"
          header-align="center"
          align="center"
          width="350"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.durationTime.open">
              {{ scope.row.durationTime.open | dateTimeThShort }} -
              {{ new Date(scope.row.durationTime.close).setHours(23,59,59) | dateTimeThShort }}
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="updatedAt"
          label="วันที่และเวลาที่อัปเดต"
          :width="
            widthMax < 767.98
              ? '130'
              : widthMax < 1199
              ? '130'
              : widthMax > 1200
              ? '250'
              : ''
          "
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">{{
            scope.row.updatedAt | dateTimeTh
          }}</template>
        </el-table-column>
        <el-table-column label width="100" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="flex-display ai-center js-center">
              <div class="box-action">
                <div
                  @click="openEditTopic(scope.row)"
                  class="circle-action color-bg-secondary"
                >
                  <i class="fas fa-pen"></i>
                </div>
              </div>
              <div class="box-action">
                <el-popconfirm
                  confirmButtonText="ใช่"
                  cancelButtonText="ไม่"
                  icon="el-icon-info"
                  iconColor="red"
                  title="ท่านต้องการลบรายการนี้ใช่หรือไม่"
                  @onConfirm="delTopic(scope.row._id)"
                >
                  <div
                    slot="reference"
                    class="circle-action color-bg-danger-lighter"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </div>
                </el-popconfirm>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title :visible.sync="dialogTopicVisible" width="90%" top="1vh">
      <div >
        <div class="text-left pd-b-3 border-b">
          <h2 class="mg-less text-font-24 color-black">
            {{ topicEdit == false ? "เพิ่มหัวข้อ" : "แก้ไขหัวข้อ" }}
          </h2>
        </div>
        <div v-if="dialogTopicVisible" class="pd-t-1 modal-page">
          <TopicForm
            @createTopic="createTopic"
            @updateTopic="updateTopic"
            :topic="topic"
            :type="topicEdit == false ? 'add' : 'update'"
            :startDate="subject.durationTime.open"
            :endDate="subject.durationTime.close"
          />
        </div>
        <el-dialog 
          title="กำลังอัพโหลดข้อมูล..." 
          :visible.sync="dialogProgress" 
          :show-close="false" 
          :close-on-click-modal="false" 
          :close-on-press-escape="false" 
          :modal="false"
          top="25vh" 
          :width="widthMax < 767.98?'80%':null"
          class="text-center padding-top-10">
            <el-progress type="circle" :percentage="progress" :width="widthMax < 767.98?200:250" :color="[
                {color: '#ff8f8c', percentage: 30},
                {color: '#ffb800', percentage: 60},
                {color: '#04cc24', percentage: 80}
            ]"></el-progress>
        </el-dialog>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { tableHeaderStyle } from "@/service/table";
import TopicForm from "@/components/topic/TopicForm";
import { HTTP } from "@/service/axios.js";

export default {
  components: {
    TopicForm,
  },
  props: {
    topicList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    courseList() {
      return this.$store.state.courseList;
    },
  },
  data() {
    return {
      widthMax: window.innerWidth,
      showTable:true,
      dialogTopicVisible: false,
      topicEdit: false,
      loading: false,
      loadingTable: false,
      urlCouse: process.env.VUE_APP_BASE_URL_FILE_COURSE,
      topic: null,
      dialogProgress:false,
      progress:0,
      subject: "",
    };
  },
  mounted() {
    this.setCourse()
    window.addEventListener("resize", this.resize);
  },
  methods: {
    resize() {
      this.showTable = false
      this.widthMax= window.innerWidth
      setTimeout(() => {
        this.showTable = true
      }, 200);

    },
    setCourse() {
      let filter = this.courseList.filter(
        (filter) => filter._id == this.$route.query.courseId
      );

      if (filter.length > 0) {
        let course = filter[0].subject.filter(
          (filter) => filter._id == this.$route.query.subjectId
        );
        if (course.length > 0) {
          this.subject = course[0];
        }
      }
    },
    delTopic(id) {
      this.loadingTable = true;
      let obj = {
        courseId: this.$route.query.courseId,
        subjectId: this.$route.query.subjectId,
        id: id,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`delete/topic`, obj)
        .then((res) => {
          if (res.data.success) {
            this.$emit("fetchSubjectId");
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("delTopic error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loadingTable = false;
          }, 500);
        });
    },
    createTopic(data) {
      this.progress = 0
      this.dialogProgress = true

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      let formData = new FormData();
      formData.append("courseId", this.$route.query.courseId);
      formData.append("subjectId", this.$route.query.subjectId);
      formData.append("topic", data.topicName);
      formData.append("detail", data.topicDescription);

      formData.append(
        "durationTime",
        JSON.stringify({
          open: data.topicDistanceDate[0],
          close: data.topicDistanceDate[1],
        })
      );

      formData.append("attach", data.topicClip.raw);
      formData.append("index", data.number);

      let interval = setInterval(() => {
        if (this.progress < 80) {
          this.progress += 2
        }
        setTimeout(() => {
          if (this.progress < 95) {
            this.progress += 1
          }
        }, 1000);
       
      }, 1500);

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`topic`, formData, config)
        .then((res) => {
          if (res.data.success) {
            clearInterval(interval)
            this.progress = 95
            setTimeout(() => {
                this.progress = 100
                setTimeout(() => {
                    this.dialogProgress = false
                    this.$emit("fetchSubjectId");
                    this.dialogTopicVisible = false;
                }, 500);
            }, 500);
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("updateMessage error", e);
        })
    },
    updateTopic(data, del, id) {
      this.progress = 0
      this.dialogProgress = true

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      let formData = new FormData();
      formData.append("courseId", this.$route.query.courseId);
      formData.append("subjectId", this.$route.query.subjectId);
      formData.append("topicId", id);
      formData.append("topic", data.topicName);
      formData.append("detail", data.topicDescription);

      formData.append(
        "durationTime",
        JSON.stringify({
          open: data.topicDistanceDate[0],
          close: data.topicDistanceDate[1],
        })
      );

      if (typeof data.topicClip.raw != "undefined") {
        formData.append("attach", data.topicClip.raw);
      }

      if (del.topicClipDel != "") {
        formData.append("delFile", del.topicClipDel);
      }

      formData.append("index", data.number);

      let interval = setInterval(() => {
        if (this.progress < 80) {
          this.progress += 2
        }
        setTimeout(() => {
          if (this.progress < 95) {
            this.progress += 1
          }
        }, 1000);
       
      }, 1500);

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.put(`topic`, formData, config)
        .then((res) => {
          if (res.data.success) {
            clearInterval(interval)
            this.progress = 95
            setTimeout(() => {
                this.progress = 100
                setTimeout(() => {
                    this.dialogProgress = false
                    this.$emit("fetchSubjectId");
                    this.dialogTopicVisible = false;
                }, 500);
            }, 500);
  
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("updateMessage error", e);
        })
    },
    resetTopic() {
      this.topicEdit = false;
      this.topic = null;
    },
    openEditTopic(data) {
      this.setCourse();
      this.topic = data;
      this.dialogTopicVisible = true;
      this.topicEdit = true;
     
    },
  },
};
</script>